export default {"src":"/_next/static/media/BookBG.225e9cb9.gif","height":560,"width":886,"blurWidth":0,"blurHeight":0};